module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BlackItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BlackItalic.woff
// module id = 1889
// module chunks = 0